// ==============================================================================
// Canales
// ==============================================================================

export const SUBTIPO_DEVOLUCIONES = "DEVOLUCIONES";
export const SUBTIPO_DEVOLUCIONESOPTBLUE = "DEVOLUCIONESOPTBLUE";
export const SUBTIPO_DEVOLUCIONESPAYFAC = "DEVOLUCIONESPAYFAC";
export const SUBTIPO_GAPS = "GAPS";
export const SUBTIPO_RESPUESTASEMAIL = "RESPUESTASEMAILS";
export const SUBTIPO_BANCOS = "BANCOS";
export const SUBTIPO_BANCOSOPTBLUE = "BANCOSOPTBLUE";
export const SUBTIPO_SAU = "SAU";
export const SUBTIPO_SAUOPTBLUE = "SAUOPTBLUE";
export const SUBTIPO_GAN = "GAN";
export const SUBTIPO_GANOPTBLUE = "GANOPTBLUE";
export const SUBTIPO_CID = "CID";
export const SUBTIPO_CIDOPTBLUE = "CIDOPTBLUE";
export const SUBTIPO_PLANN = "PLANN";
export const SUBTIPO_PLANNOPTBLUE = "PLANNOPTBLUE";
export const SUBTIPO_BASELINE = "BASELINE";
export const SUBTIPO_BASELINEOPTBLUE = "BASELINEOPTBLUE";
export const SUBTIPO_CANCELACIONMANUAL = "CANCELACIONMANUAL";
export const SUBTIPO_CANCELACIONMANUALOPTBLUE = "CANCELACIONMANUALOPTBLUE";
export const SUBTIPO_CAU = "CAU";
export const SUBTIPO_GESTIONESOPTBLUE = "GESTIONESOPTBLUE";
export const SUBTIPO_GESTIONESPROPIETARIO = "GESTIONESPROPIETARIO";
export const SUBTIPO_WCPROP = "WCPROP";
export const SUBTIPO_SUSP = "SUSP";
export const SUBTIPO_SE = "SE";
export const SUBTIPO_CAMPANA = "CAMPAÑA";
export const SUBTIPO_C_LST60 = "C_LST60";
export const SUBTIPO_C_MOM = "C_MOM";
export const SUBTIPO_C_WC_OB = "C_WC_OB";
export const SUBTIPO_C_WC_PROP_ONLINERRBB = "C_WC_PROP_ONLINERRBB";
export const SUBTIPO_C_RRBB = "C_RRBB";
export const SUBTIPO_C_ALIF = "C_ALIF";
export const SUBTIPO_C_PROBLEMA_POS_NO_AMEX = "C_PROBLEMA_POS_NO_AMEX";
export const SUBTIPO_C_RISKOB = "C_RISKOB";
export const SUBTIPO_C_SHSM = "C_SHSM";
export const SUBTIPO_C_BLITZ = "C_BLITZ";
export const SUBTIPO_C_CAU = "C_CAU";
export const SUBTIPO_V_LST60 = "V_LST60";
export const SUBTIPO_V_MOM = "V_MOM";
export const SUBTIPO_V_WC_OB = "V_WC_OB";
export const SUBTIPO_V_WC_PROP_POS = "V_WC_PROP_POS";
export const SUBTIPO_V_RISKOB = "V_RISKOB";
export const SUBTIPO_V_ALIF = "V_ALIF";
export const SUBTIPO_V_SHSM = "V_SHSM";
export const SUBTIPO_V_BLITZ = "V_BLITZ";
export const SUBTIPO_V_CAU = "V_CAU";
export const SUBTIPO_V_PAYFAC = "V_PAYFAC";
export const SUBTIPO_EXCLUSIONES = "EXCLUSIONES";

export const SUBTIPO_NUM_DEVOLUCIONES = "DEVOLUCIONES";
export const SUBTIPO_NUM_DEVOLUCIONESOPTBLUE = "DEVOLUCIONESOPTBLUE";
export const SUBTIPO_NUM_DEVOLUCIONESPAYFAC = "DEVOLUCIONESPAYFAC";
export const SUBTIPO_NUM_GAPS = "GAPS";
export const SUBTIPO_NUM_RESPUESTASEMAIL = "RESPUESTASEMAILS";
export const SUBTIPO_NUM_BANCOS = "BANCOS";
export const SUBTIPO_NUM_BANCOSOPTBLUE = "BANCOSOPTBLUE";
export const SUBTIPO_NUM_SAU = "SAU";
export const SUBTIPO_NUM_SAUOPTBLUE = "SAUOPTBLUE";
export const SUBTIPO_NUM_GAN = "GAN";
export const SUBTIPO_NUM_GANOPTBLUE = "GANOPTBLUE";
export const SUBTIPO_NUM_CID = "CID";
export const SUBTIPO_NUM_CIDOPTBLUE = "CIDOPTBLUE";
export const SUBTIPO_NUM_PLANN = "PLANN";
export const SUBTIPO_NUM_PLANNOPTBLUE = "PLANNOPTBLUE";
export const SUBTIPO_NUM_BASELINE = "BASELINE";
export const SUBTIPO_NUM_BASELINEOPTBLUE = "BASELINEOPTBLUE";
export const SUBTIPO_NUM_CANCELACIONMANUAL = "CANCELACIONMANUAL";
export const SUBTIPO_NUM_CANCELACIONMANUALOPTBLUE = "CANCELACIONMANUALOPTBLUE";
export const SUBTIPO_NUM_CAU = "CAU";
export const SUBTIPO_NUM_GESTIONESOPTBLUE = "GESTIONESOPTBLUE";
export const SUBTIPO_NUM_GESTIONESPROPIETARIO = "GESTIONESPROPIETARIO";
export const SUBTIPO_NUM_WCPROP = "WCPROP";
export const SUBTIPO_NUM_SUSP = "SUSP";
export const SUBTIPO_NUM_SE = "SE";
export const SUBTIPO_NUM_CAMPANA = "CAMPANA";
export const SUBTIPO_NUM_C_LST60 = "C_LST60";
export const SUBTIPO_NUM_C_MOM = "C_MOM";
export const SUBTIPO_NUM_C_WC_OB = "C_WC_OB";
export const SUBTIPO_NUM_C_WC_PROP_ONLINERRBB = "C_WC_PROP_ONLINERRBB";
export const SUBTIPO_NUM_C_RRBB = "C_RRBB";
export const SUBTIPO_NUM_C_ALIF = "C_ALIF";
export const SUBTIPO_NUM_C_PROBLEMA_POS_NO_AMEX = "C_PROBLEMA_POS_NO_AMEX";
export const SUBTIPO_NUM_C_RISKOB = "C_RISKOB";
export const SUBTIPO_NUM_C_SHSM = "C_SHSM";
export const SUBTIPO_NUM_C_BLITZ = "C_BLITZ";
export const SUBTIPO_NUM_C_CAU = "C_CAU";
export const SUBTIPO_NUM_V_LST60 = "V_LST60";
export const SUBTIPO_NUM_V_MOM = "V_MOM";
export const SUBTIPO_NUM_V_WC_OB = "V_WC_OB";
export const SUBTIPO_NUM_V_WC_PROP_POS = "V_WC_PROP_POS";
export const SUBTIPO_NUM_V_RISKOB = "V_RISKOB";
export const SUBTIPO_NUM_V_ALIF = "V_ALIF";
export const SUBTIPO_NUM_V_SHSM = "V_SHSM";
export const SUBTIPO_NUM_V_BLITZ = "V_BLITZ";
export const SUBTIPO_NUM_V_CAU = "V_CAU";
export const SUBTIPO_NUM_V_PAYFAC = "V_PAYFAC";
export const SUBTIPO_NUM_EXCLUSIONES = "EXCLUSIONES";

export const TIPO_CANAL = {
  DEVOLUCIONES: SUBTIPO_DEVOLUCIONES
  , DEVOLUCIONESOPTBLUE: SUBTIPO_DEVOLUCIONESOPTBLUE
  , DEVOLUCIONESPAYFAC: SUBTIPO_DEVOLUCIONESPAYFAC
  , GAPS: SUBTIPO_GAPS
};

export const TIPO_DIM = {
  RESPUESTASEMAILS: SUBTIPO_RESPUESTASEMAIL
  , BANCOS: SUBTIPO_BANCOS
  , BANCOSOPTBLUE: SUBTIPO_BANCOSOPTBLUE
  , SAU: SUBTIPO_SAU
  , SAUOPTBLUE: SUBTIPO_SAUOPTBLUE
  , GAN: SUBTIPO_GAN
  , GANOPTBLUE: SUBTIPO_GANOPTBLUE
  , CID: SUBTIPO_CID
  , CIDOPTBLUE: SUBTIPO_CIDOPTBLUE
  , PLANN: SUBTIPO_PLANN
  , PLANNOPTBLUE: SUBTIPO_PLANNOPTBLUE
  , BASELINE: SUBTIPO_BASELINE
  , BASELINEOPTBLUE: SUBTIPO_BASELINEOPTBLUE
  , CANCELACIONMANUAL: SUBTIPO_CANCELACIONMANUAL
  , CANCELACIONMANUALOPTBLUE: SUBTIPO_CANCELACIONMANUALOPTBLUE
  , CAU: SUBTIPO_CAU
  , GESTIONESOPTBLUE: SUBTIPO_GESTIONESOPTBLUE
  , GESTIONESPROPIETARIO: SUBTIPO_GESTIONESPROPIETARIO
  , WCPROP: SUBTIPO_WCPROP
  , SUSP: SUBTIPO_SUSP
};

export const TIPO_IMPORT = {
  SE: SUBTIPO_SE
  , CAMPANA: SUBTIPO_CAMPANA
  , C_LST60: SUBTIPO_C_LST60
  , C_MOM: SUBTIPO_C_MOM
  , C_WC_OB: SUBTIPO_C_WC_OB
  , C_WC_PROP_ONLINERRBB: SUBTIPO_C_WC_PROP_ONLINERRBB
  , C_RRBB: SUBTIPO_C_RRBB
  , C_ALIF: SUBTIPO_C_ALIF
  , C_PROBLEMA_POS_NO_AMEX: SUBTIPO_C_PROBLEMA_POS_NO_AMEX
  , C_RISKOB: SUBTIPO_C_RISKOB
  , C_SHSM: SUBTIPO_C_SHSM
  , C_BLITZ: SUBTIPO_C_BLITZ
  , C_CAU: SUBTIPO_C_CAU
  , V_LST60: SUBTIPO_V_LST60
  , V_MOM: SUBTIPO_V_MOM
  , V_WC_OB: SUBTIPO_V_WC_OB
  , V_WC_PROP_POS: SUBTIPO_V_WC_PROP_POS
  , V_RISKOB: SUBTIPO_V_RISKOB
  , V_ALIF: SUBTIPO_V_ALIF
  , V_SHSM: SUBTIPO_V_SHSM
  , V_BLITZ: SUBTIPO_V_BLITZ
  , V_CAU: SUBTIPO_V_CAU
  , V_PAYFAC: SUBTIPO_V_PAYFAC
  , EXCLUSIONES: SUBTIPO_EXCLUSIONES
};

export const CANALES_SELECT = [
  { code: SUBTIPO_NUM_DEVOLUCIONES, name: SUBTIPO_DEVOLUCIONES }
  , { code: SUBTIPO_NUM_DEVOLUCIONESOPTBLUE, name: SUBTIPO_DEVOLUCIONESOPTBLUE }
  , { code: SUBTIPO_NUM_DEVOLUCIONESPAYFAC, name: SUBTIPO_DEVOLUCIONESPAYFAC }
  , { code: SUBTIPO_NUM_GAPS, name: SUBTIPO_GAPS }
  , { code: SUBTIPO_NUM_RESPUESTASEMAIL, name: SUBTIPO_RESPUESTASEMAIL }
  , { code: SUBTIPO_NUM_BANCOS, name: SUBTIPO_BANCOS }
  , { code: SUBTIPO_NUM_BANCOSOPTBLUE, name: SUBTIPO_BANCOSOPTBLUE }
  , { code: SUBTIPO_NUM_SAU, name: SUBTIPO_SAU }
  , { code: SUBTIPO_NUM_SAUOPTBLUE, name: SUBTIPO_SAUOPTBLUE }
  , { code: SUBTIPO_NUM_GAN, name: SUBTIPO_GAN }
  , { code: SUBTIPO_NUM_GANOPTBLUE, name: SUBTIPO_GANOPTBLUE }
  , { code: SUBTIPO_NUM_CID, name: SUBTIPO_CID }
  , { code: SUBTIPO_NUM_CIDOPTBLUE, name: SUBTIPO_CIDOPTBLUE }
  , { code: SUBTIPO_NUM_PLANN, name: SUBTIPO_PLANN }
  , { code: SUBTIPO_NUM_PLANNOPTBLUE, name: SUBTIPO_PLANNOPTBLUE }
  , { code: SUBTIPO_NUM_BASELINE, name: SUBTIPO_BASELINE }
  , { code: SUBTIPO_NUM_BASELINEOPTBLUE, name: SUBTIPO_BASELINEOPTBLUE }
  , { code: SUBTIPO_NUM_CANCELACIONMANUAL, name: SUBTIPO_CANCELACIONMANUAL }
  , { code: SUBTIPO_NUM_CANCELACIONMANUALOPTBLUE, name: SUBTIPO_CANCELACIONMANUALOPTBLUE }
  , { code: SUBTIPO_NUM_CAU, name: SUBTIPO_CAU }
  , { code: SUBTIPO_NUM_GESTIONESOPTBLUE, name: SUBTIPO_GESTIONESOPTBLUE }
  , { code: SUBTIPO_NUM_GESTIONESPROPIETARIO, name: SUBTIPO_GESTIONESPROPIETARIO }
  , { code: SUBTIPO_NUM_WCPROP, name: SUBTIPO_WCPROP }
  , { code: SUBTIPO_NUM_SUSP, name: SUBTIPO_SUSP }
];

export const SUBTIPO_SELECT = [
  { code: SUBTIPO_NUM_DEVOLUCIONES, name: SUBTIPO_DEVOLUCIONES }
  , { code: SUBTIPO_NUM_DEVOLUCIONESOPTBLUE, name: SUBTIPO_DEVOLUCIONESOPTBLUE }
  , { code: SUBTIPO_NUM_DEVOLUCIONESPAYFAC, name: SUBTIPO_DEVOLUCIONESPAYFAC }
  , { code: SUBTIPO_NUM_GAPS, name: SUBTIPO_GAPS }
  , { code: SUBTIPO_NUM_RESPUESTASEMAIL, name: SUBTIPO_RESPUESTASEMAIL }
  , { code: SUBTIPO_NUM_BANCOS, name: SUBTIPO_BANCOS }
  , { code: SUBTIPO_NUM_BANCOSOPTBLUE, name: SUBTIPO_BANCOSOPTBLUE }
  , { code: SUBTIPO_NUM_SAU, name: SUBTIPO_SAU }
  , { code: SUBTIPO_NUM_SAUOPTBLUE, name: SUBTIPO_SAUOPTBLUE }
  , { code: SUBTIPO_NUM_GAN, name: SUBTIPO_GAN }
  , { code: SUBTIPO_NUM_GANOPTBLUE, name: SUBTIPO_GANOPTBLUE }
  , { code: SUBTIPO_NUM_CID, name: SUBTIPO_CID }
  , { code: SUBTIPO_NUM_CIDOPTBLUE, name: SUBTIPO_CIDOPTBLUE }
  , { code: SUBTIPO_NUM_PLANN, name: SUBTIPO_PLANN }
  , { code: SUBTIPO_NUM_PLANNOPTBLUE, name: SUBTIPO_PLANNOPTBLUE }
  , { code: SUBTIPO_NUM_BASELINE, name: SUBTIPO_BASELINE }
  , { code: SUBTIPO_NUM_BASELINEOPTBLUE, name: SUBTIPO_BASELINEOPTBLUE }
  , { code: SUBTIPO_NUM_CANCELACIONMANUAL, name: SUBTIPO_CANCELACIONMANUAL }
  , { code: SUBTIPO_NUM_CANCELACIONMANUALOPTBLUE, name: SUBTIPO_CANCELACIONMANUALOPTBLUE }
  , { code: SUBTIPO_NUM_CAU, name: SUBTIPO_CAU }
  , { code: SUBTIPO_NUM_GESTIONESOPTBLUE, name: SUBTIPO_GESTIONESOPTBLUE }
  , { code: SUBTIPO_NUM_GESTIONESPROPIETARIO, name: SUBTIPO_GESTIONESPROPIETARIO }
  , { code: SUBTIPO_NUM_WCPROP, name: SUBTIPO_WCPROP }
  , { code: SUBTIPO_NUM_SUSP, name: SUBTIPO_SUSP }
  , { code: SUBTIPO_NUM_SE, name: SUBTIPO_SE }
  , { code: SUBTIPO_NUM_CAMPANA, name: SUBTIPO_CAMPANA }
  , { code: SUBTIPO_NUM_C_LST60, name: SUBTIPO_C_LST60 }
  , { code: SUBTIPO_NUM_C_LST60, name: SUBTIPO_C_LST60 }
  , { code: SUBTIPO_NUM_C_MOM, name: SUBTIPO_C_MOM }
  , { code: SUBTIPO_NUM_C_WC_OB, name: SUBTIPO_C_WC_OB }
  , { code: SUBTIPO_NUM_C_WC_PROP_ONLINERRBB, name: SUBTIPO_C_WC_PROP_ONLINERRBB }
  , { code: SUBTIPO_NUM_C_RRBB, name: SUBTIPO_C_RRBB }
  , { code: SUBTIPO_NUM_C_ALIF, name: SUBTIPO_C_ALIF }
  , { code: SUBTIPO_NUM_C_PROBLEMA_POS_NO_AMEX, name: SUBTIPO_C_PROBLEMA_POS_NO_AMEX }
  , { code: SUBTIPO_NUM_C_RISKOB, name: SUBTIPO_C_RISKOB }
  , { code: SUBTIPO_NUM_C_SHSM, name: SUBTIPO_C_SHSM }
  , { code: SUBTIPO_NUM_C_BLITZ, name: SUBTIPO_C_BLITZ }
  , { code: SUBTIPO_NUM_C_CAU, name: SUBTIPO_C_CAU }
  , { code: SUBTIPO_NUM_V_LST60, name: SUBTIPO_V_LST60 }
  , { code: SUBTIPO_NUM_V_MOM, name: SUBTIPO_V_MOM }
  , { code: SUBTIPO_NUM_V_WC_OB, name: SUBTIPO_V_WC_OB }
  , { code: SUBTIPO_NUM_V_WC_PROP_POS, name: SUBTIPO_V_WC_PROP_POS }
  , { code: SUBTIPO_NUM_V_RISKOB, name: SUBTIPO_V_RISKOB }
  , { code: SUBTIPO_NUM_V_ALIF, name: SUBTIPO_V_ALIF }
  , { code: SUBTIPO_NUM_V_SHSM, name: SUBTIPO_V_SHSM }
  , { code: SUBTIPO_NUM_V_BLITZ, name: SUBTIPO_V_BLITZ }
  , { code: SUBTIPO_NUM_V_CAU, name: SUBTIPO_V_CAU }
  , { code: SUBTIPO_NUM_V_PAYFAC, name: SUBTIPO_V_PAYFAC }
  , { code: SUBTIPO_NUM_EXCLUSIONES, name: SUBTIPO_EXCLUSIONES }
];

export const TIPO_CANAL_SELECT = [
  { code: SUBTIPO_NUM_DEVOLUCIONES, name: SUBTIPO_DEVOLUCIONES }
  , { code: SUBTIPO_NUM_DEVOLUCIONESOPTBLUE, name: SUBTIPO_DEVOLUCIONESOPTBLUE }
  , { code: SUBTIPO_NUM_DEVOLUCIONESPAYFAC, name: SUBTIPO_DEVOLUCIONESPAYFAC }
  , { code: SUBTIPO_NUM_GAPS, name: SUBTIPO_GAPS }
];

export const TIPO_DIM_SELECT = [
  { code: SUBTIPO_NUM_RESPUESTASEMAIL, name: SUBTIPO_RESPUESTASEMAIL }
  , { code: SUBTIPO_NUM_BANCOS, name: SUBTIPO_BANCOS }
  , { code: SUBTIPO_NUM_BANCOSOPTBLUE, name: SUBTIPO_BANCOSOPTBLUE }
  , { code: SUBTIPO_NUM_SAU, name: SUBTIPO_SAU }
  , { code: SUBTIPO_NUM_SAUOPTBLUE, name: SUBTIPO_SAUOPTBLUE }
  , { code: SUBTIPO_NUM_GAN, name: SUBTIPO_GAN }
  , { code: SUBTIPO_NUM_GANOPTBLUE, name: SUBTIPO_GANOPTBLUE }
  , { code: SUBTIPO_NUM_CID, name: SUBTIPO_CID }
  , { code: SUBTIPO_NUM_CIDOPTBLUE, name: SUBTIPO_CIDOPTBLUE }
  , { code: SUBTIPO_NUM_PLANN, name: SUBTIPO_PLANN }
  , { code: SUBTIPO_NUM_PLANNOPTBLUE, name: SUBTIPO_PLANNOPTBLUE }
  , { code: SUBTIPO_NUM_BASELINE, name: SUBTIPO_BASELINE }
  , { code: SUBTIPO_NUM_BASELINEOPTBLUE, name: SUBTIPO_BASELINEOPTBLUE }
  , { code: SUBTIPO_NUM_CANCELACIONMANUAL, name: SUBTIPO_CANCELACIONMANUAL }
  , { code: SUBTIPO_NUM_CANCELACIONMANUALOPTBLUE, name: SUBTIPO_CANCELACIONMANUALOPTBLUE }
  , { code: SUBTIPO_NUM_CAU, name: SUBTIPO_CAU }
  , { code: SUBTIPO_NUM_GESTIONESOPTBLUE, name: SUBTIPO_GESTIONESOPTBLUE }
  , { code: SUBTIPO_NUM_GESTIONESPROPIETARIO, name: SUBTIPO_GESTIONESPROPIETARIO }
  , { code: SUBTIPO_NUM_WCPROP, name: SUBTIPO_WCPROP }
  , { code: SUBTIPO_NUM_SUSP, name: SUBTIPO_SUSP }
];

export const TIPO_IMPORT_SELECT = [
  { code: SUBTIPO_NUM_SE, name: SUBTIPO_SE }
  , { code: SUBTIPO_NUM_CAMPANA, name: SUBTIPO_CAMPANA }
  , { code: SUBTIPO_NUM_C_LST60, name: SUBTIPO_C_LST60 }
  , { code: SUBTIPO_NUM_C_LST60, name: SUBTIPO_C_LST60 }
  , { code: SUBTIPO_NUM_C_MOM, name: SUBTIPO_C_MOM }
  , { code: SUBTIPO_NUM_C_WC_OB, name: SUBTIPO_C_WC_OB }
  , { code: SUBTIPO_NUM_C_WC_PROP_ONLINERRBB, name: SUBTIPO_C_WC_PROP_ONLINERRBB }
  , { code: SUBTIPO_NUM_C_RRBB, name: SUBTIPO_C_RRBB }
  , { code: SUBTIPO_NUM_C_ALIF, name: SUBTIPO_C_ALIF }
  , { code: SUBTIPO_NUM_C_PROBLEMA_POS_NO_AMEX, name: SUBTIPO_C_PROBLEMA_POS_NO_AMEX }
  , { code: SUBTIPO_NUM_C_RISKOB, name: SUBTIPO_C_RISKOB }
  , { code: SUBTIPO_NUM_C_SHSM, name: SUBTIPO_C_SHSM }
  , { code: SUBTIPO_NUM_C_BLITZ, name: SUBTIPO_C_BLITZ }
  , { code: SUBTIPO_NUM_C_CAU, name: SUBTIPO_C_CAU }
  , { code: SUBTIPO_NUM_V_LST60, name: SUBTIPO_V_LST60 }
  , { code: SUBTIPO_NUM_V_MOM, name: SUBTIPO_V_MOM }
  , { code: SUBTIPO_NUM_V_WC_OB, name: SUBTIPO_V_WC_OB }
  , { code: SUBTIPO_NUM_V_WC_PROP_POS, name: SUBTIPO_V_WC_PROP_POS }
  , { code: SUBTIPO_NUM_V_RISKOB, name: SUBTIPO_V_RISKOB }
  , { code: SUBTIPO_NUM_V_ALIF, name: SUBTIPO_V_ALIF }
  , { code: SUBTIPO_NUM_V_SHSM, name: SUBTIPO_V_SHSM }
  , { code: SUBTIPO_NUM_V_BLITZ, name: SUBTIPO_V_BLITZ }
  , { code: SUBTIPO_NUM_V_CAU, name: SUBTIPO_V_CAU }
  , { code: SUBTIPO_NUM_V_PAYFAC, name: SUBTIPO_V_PAYFAC }
  , { code: SUBTIPO_NUM_EXCLUSIONES, name: SUBTIPO_EXCLUSIONES }
  , { code: SUBTIPO_NUM_DEVOLUCIONES, name: SUBTIPO_DEVOLUCIONES }
  , { code: SUBTIPO_NUM_DEVOLUCIONESOPTBLUE, name: SUBTIPO_DEVOLUCIONESOPTBLUE }
];

export const TIPO_IMPORT_BASE_SELECT = [
  { code: SUBTIPO_NUM_C_LST60, name: SUBTIPO_C_LST60 }
  , { code: SUBTIPO_NUM_C_LST60, name: SUBTIPO_C_LST60 }
  , { code: SUBTIPO_NUM_C_MOM, name: SUBTIPO_C_MOM }
  , { code: SUBTIPO_NUM_C_WC_OB, name: SUBTIPO_C_WC_OB }
  , { code: SUBTIPO_NUM_C_WC_PROP_ONLINERRBB, name: SUBTIPO_C_WC_PROP_ONLINERRBB }
  , { code: SUBTIPO_NUM_C_RRBB, name: SUBTIPO_C_RRBB }
  , { code: SUBTIPO_NUM_C_ALIF, name: SUBTIPO_C_ALIF }
  , { code: SUBTIPO_NUM_C_PROBLEMA_POS_NO_AMEX, name: SUBTIPO_C_PROBLEMA_POS_NO_AMEX }
  , { code: SUBTIPO_NUM_C_RISKOB, name: SUBTIPO_C_RISKOB }
  , { code: SUBTIPO_NUM_C_SHSM, name: SUBTIPO_C_SHSM }
  , { code: SUBTIPO_NUM_C_BLITZ, name: SUBTIPO_C_BLITZ }
  , { code: SUBTIPO_NUM_C_CAU, name: SUBTIPO_C_CAU }
  , { code: SUBTIPO_NUM_V_LST60, name: SUBTIPO_V_LST60 }
  , { code: SUBTIPO_NUM_V_MOM, name: SUBTIPO_V_MOM }
  , { code: SUBTIPO_NUM_V_WC_OB, name: SUBTIPO_V_WC_OB }
  , { code: SUBTIPO_NUM_V_WC_PROP_POS, name: SUBTIPO_V_WC_PROP_POS }
  , { code: SUBTIPO_NUM_V_RISKOB, name: SUBTIPO_V_RISKOB }
  , { code: SUBTIPO_NUM_V_ALIF, name: SUBTIPO_V_ALIF }
  , { code: SUBTIPO_NUM_V_SHSM, name: SUBTIPO_V_SHSM }
  , { code: SUBTIPO_NUM_V_BLITZ, name: SUBTIPO_V_BLITZ }
  , { code: SUBTIPO_NUM_V_CAU, name: SUBTIPO_V_CAU }
  , { code: SUBTIPO_NUM_V_PAYFAC, name: SUBTIPO_V_PAYFAC }
  , { code: SUBTIPO_NUM_EXCLUSIONES, name: SUBTIPO_EXCLUSIONES }
];

export const TIPO_CONTACTO_SELECT = [
  { code: "C", name: "LLAMADAS" }
  , { code: "V", name: "VISITAS" }
  , { code: "E", name: "EXCLUSIONES" }
  , { code: "F", name: "FACTURACION" }
];

export const TIPO_CONTACTO_SELECTCB = [
  { code: "C", name: "LLAMADAS" }
  , { code: "V", name: "VISITAS" }
  , { code: "E", name: "EXCLUSIONES" }
];

export const STATUS_BASE_SELECT = [
  { code: "PENDIENTE", name: "PENDIENTE" }
  , { code: "EN PROCESO", name: "EN_PROCESO" }
  , { code: "ENVIADA", name: "ENVIADA" }
  , { code: "CANCELADO", name: "CANCELADO" }
  , { code: "APLICADA", name: "APLICADA" }
  , { code: "EXCLUIDO", name: "EXCLUIDO" }
];

export const TIPO_FORM_SELECT = [
  { code: "DEVOLUCIONES", name: "DEVOLUCIONES" }
  , { code: "GAPS", name: "GAPS" }
  , { code: "PAYFAC", name: "PAYFAC" }
];

// ==============================================================================
// Tipos
// ==============================================================================

export const TIPO_OPTBLUE = "OPTBLUE";
export const TIPO_BLITZ = "BLITZ";
export const TIPO_ACQ = "ACQ";
export const TIPO_PROP = "PROP";
export const TIPO_BO = "BO";

export const TIPO_NUM_OPTBLUE = "OPTBLUE";
export const TIPO_NUM_BLITZ = "BLITZ";
export const TIPO_NUM_ACQ = "ACQ";
export const TIPO_NUM_PROP = "PROP";
export const TIPO_NUM_BO = "BO";

export const TIPO = {
  OPTBLUE: TIPO_OPTBLUE
  , BLITZ: TIPO_BLITZ
  , ACQ: TIPO_ACQ
  , PROP: TIPO_PROP
  , BO: TIPO_BO
};

export const TIPO_SELECT = [
  { code: TIPO_NUM_OPTBLUE, name: TIPO_OPTBLUE }
  , { code: TIPO_NUM_BLITZ, name: TIPO_BLITZ }
  , { code: TIPO_NUM_ACQ, name: TIPO_ACQ }
  , { code: TIPO_NUM_PROP, name: TIPO_PROP }
  , { code: TIPO_NUM_BO, name: TIPO_BO }
];

// ==============================================================================
// SE Negocio
// ==============================================================================

export const SE_NEGOCIO_PROP = "PROP";
export const SE_NEGOCIO_OPTBLUE = "OPTBLUE";
export const SE_NEGOCIO_PAYFAC = "PAYFAC";
export const SE_NEGOCIO_PAYFACSID = "PAYFACSID";

export const SE_NEGOCIO_NUM_PROP = "PROP";
export const SE_NEGOCIO_NUM_OPTBLUE = "OPTBLUE";
export const SE_NEGOCIO_NUM_PAYFAC = "PAYFAC";
export const SE_NEGOCIO_NUM_PAYFACSID = "PAYFACSID";

export const SE_NEGOCIO_TABLE = {
  PROP: { name: SE_NEGOCIO_PROP, color: "grey lighten-2" }
  , OPTBLUE: { name: SE_NEGOCIO_OPTBLUE, color: "secondary" }
  , PAYFAC: { name: SE_NEGOCIO_PAYFAC, color: "orange lighten-2" }
  , PAYFACSID: { name: SE_NEGOCIO_PAYFACSID, color: "primary" }
};

export const SE_NEGOCIO_SELECT = [
  { code: SE_NEGOCIO_NUM_PROP, name: SE_NEGOCIO_PROP }
  , { code: SE_NEGOCIO_NUM_OPTBLUE, name: SE_NEGOCIO_OPTBLUE }
  , { code: SE_NEGOCIO_NUM_PAYFAC, name: SE_NEGOCIO_PAYFAC }
  , { code: SE_NEGOCIO_NUM_PAYFACSID, name: SE_NEGOCIO_PAYFACSID }
];

// ==============================================================================
// Tipo Archivo
// ==============================================================================

export const TIPO_ARCHIVO_CANAL = "CANAL";
export const TIPO_ARCHIVO_DIM = "DIM";
export const TIPO_ARCHIVO_IMPORT = "IMPORT";

export const TIPO_ARCHIVO_NUM_CANAL = "CANAL";
export const TIPO_ARCHIVO_NUM_DIM = "DIM";
export const TIPO_ARCHIVO_NUM_IMPORT = "IMPORT";

export const TIPO_ARCHIVO_SELECT = [
  { code: TIPO_ARCHIVO_NUM_CANAL, name: TIPO_ARCHIVO_NUM_CANAL }
  , { code: TIPO_ARCHIVO_NUM_DIM, name: TIPO_ARCHIVO_NUM_DIM }
  , { code: TIPO_ARCHIVO_NUM_IMPORT, name: TIPO_ARCHIVO_IMPORT }
];

// ==============================================================================
// Estatus Validador
// ==============================================================================

export const VACH_STATUS_PENDIENTE = "Pendiente de validar";
export const VACH_STATUS_PROCESO = "Validación en proceso";
export const VACH_STATUS_VALIDADO = "Validación correcta";
export const VACH_STATUS_ENVIANDO = "Envío a SFTP en proceso";
export const VACH_STATUS_ENVIADO = "Enviado a SFTP";
export const VACH_STATUS_ERROR = "Error";
export const VACH_STATUS_ERROR_ENVIO = "Error de Envío";
export const VACH_STATUS_RE_ENVIO = "Reenvío a SFTP Pendiente";
export const VACH_STATUS_ERROR_ENVIO_EMAIL = "Error de Envío Email";
export const VACH_STATUS_PENDIENTE_ENVIO_SFTP = "Pendiente de Envío SFTP";

export const VACH_STATUS_NUM_PENDIENTE = 0;
export const VACH_STATUS_NUM_PROCESO = 1;
export const VACH_STATUS_NUM_VALIDADO = 2;
export const VACH_STATUS_NUM_ENVIANDO = 3;
export const VACH_STATUS_NUM_ENVIADO = 4;
export const VACH_STATUS_NUM_ERROR = 5;
export const VACH_STATUS_NUM_ERROR_ENVIO = 6;
export const VACH_STATUS_NUM_RE_ENVIO = 7;
export const VACH_STATUS_NUM_ERROR_ENVIO_EMAIL = 8;
export const VACH_STATUS_NUM_PENDIENTE_ENVIO_SFTP = 9;

export const VACH_STATUS = {
  0: VACH_STATUS_PENDIENTE
  , 1: VACH_STATUS_PROCESO
  , 2: VACH_STATUS_VALIDADO
  , 3: VACH_STATUS_ENVIANDO
  , 4: VACH_STATUS_ENVIADO
  , 5: VACH_STATUS_ERROR
  , 6: VACH_STATUS_ERROR_ENVIO
  , 7: VACH_STATUS_RE_ENVIO
  , 8: VACH_STATUS_ERROR_ENVIO_EMAIL
  , 9: VACH_STATUS_PENDIENTE_ENVIO_SFTP
};

export const VACH_STATUS_TABLE = {
  0: { name: VACH_STATUS_PENDIENTE, color: "#0077BC", icon: "fas fa-spinner fa-pulse" }
  , 1: { name: VACH_STATUS_PROCESO, color: "#0077BC", icon: "fas fa-spinner fa-pulse" }
  , 2: { name: VACH_STATUS_VALIDADO, color: "green", icon: "fas fa-check" }
  , 3: { name: VACH_STATUS_ENVIANDO, color: "#0077BC", icon: "fas fa-spinner fa-pulse" }
  , 4: { name: VACH_STATUS_ENVIADO, color: "green", icon: "fas fa-paper-plane" }
  , 5: { name: VACH_STATUS_ERROR, color: "red", icon: "fas fa-exclamation-circle" }
  , 6: { name: VACH_STATUS_ERROR_ENVIO, color: "red", icon: "fas fa-exclamation-circle" }
  , 7: { name: VACH_STATUS_RE_ENVIO, color: "#0077BC", icon: "fas fa-undo-alt" }
  , 8: { name: VACH_STATUS_ERROR_ENVIO_EMAIL, color: "red", icon: "fas fa-exclamation-circle" }
  , 9: { name: VACH_STATUS_PENDIENTE_ENVIO_SFTP, color: "#0077BC", icon: "fas fa-exclamation-circle" }
};

export const VACH_STATUS_SELECT = [
  { code: VACH_STATUS_NUM_PENDIENTE, name: VACH_STATUS_PENDIENTE, color: "#0077BC", icon: "fas fa-spinner fa-pulse" }
  , { code: VACH_STATUS_NUM_PROCESO, name: VACH_STATUS_PROCESO, color: "#0077BC", icon: "fas fa-spinner fa-pulse" }
  , { code: VACH_STATUS_NUM_VALIDADO, name: VACH_STATUS_VALIDADO, color: "green", icon: "fas fa-check" }
  , { code: VACH_STATUS_NUM_ENVIANDO, name: VACH_STATUS_ENVIANDO, color: "#0077BC", icon: "fas fa-spinner fa-pulse" }
  , { code: VACH_STATUS_NUM_ENVIADO, name: VACH_STATUS_ENVIADO, color: "green", icon: "fas fa-paper-plane" }
  , { code: VACH_STATUS_NUM_ERROR, name: VACH_STATUS_ERROR, color: "red", icon: "fas fa-exclamation-circle" }
  , { code: VACH_STATUS_NUM_ERROR_ENVIO, name: VACH_STATUS_ERROR_ENVIO, color: "red", icon: "fas fa-exclamation-circle" }
  , { code: VACH_STATUS_NUM_RE_ENVIO, name: VACH_STATUS_RE_ENVIO, color: "#0077BC", icon: "fas fa-undo-alt" }
  , { code: VACH_STATUS_NUM_ERROR_ENVIO_EMAIL, name: VACH_STATUS_ERROR_ENVIO_EMAIL, color: "red", icon: "fas fa-exclamation-circle" }
  , { code: VACH_STATUS_NUM_PENDIENTE_ENVIO_SFTP, name: VACH_STATUS_PENDIENTE_ENVIO_SFTP, color: "#0077BC", icon: "fas fa-history" }
];

// ==============================================================================
// Estatus Importador
// ==============================================================================

export const IACH_STATUS_PENDIENTE = "Pendiente de Importar";
export const IACH_STATUS_PROCESO = "Importación en proceso";
export const IACH_STATUS_IMPORTADO = "Importación correcta";
export const IACH_STATUS_ERROR = "Error";
export const IACH_STATUS_ERROR_ENVIO_EMAIL = "Error de Envío Email";

export const IACH_STATUS_NUM_PENDIENTE = 0;
export const IACH_STATUS_NUM_PROCESO = 1;
export const IACH_STATUS_NUM_IMPORTADO = 2;
export const IACH_STATUS_NUM_ERROR = 5;
export const IACH_STATUS_NUM_ERROR_ENVIO_EMAIL = 8;

export const IACH_STATUS = {
  0: IACH_STATUS_PENDIENTE
  , 1: IACH_STATUS_PROCESO
  , 2: IACH_STATUS_IMPORTADO
  , 5: IACH_STATUS_ERROR
  , 8: IACH_STATUS_ERROR_ENVIO_EMAIL
};

export const IACH_STATUS_TABLE = {
  0: { name: IACH_STATUS_PENDIENTE, color: "#0077BC", icon: "fas fa-spinner fa-pulse" }
  , 1: { name: IACH_STATUS_PROCESO, color: "#0077BC", icon: "fas fa-spinner fa-pulse" }
  , 2: { name: IACH_STATUS_IMPORTADO, color: "green", icon: "fas fa-check" }
  , 5: { name: IACH_STATUS_ERROR, color: "red", icon: "fas fa-exclamation-circle" }
  , 8: { name: IACH_STATUS_ERROR_ENVIO_EMAIL, color: "red", icon: "fas fa-exclamation-circle" }
};

export const IACH_STATUS_SELECT = [
  { code: IACH_STATUS_NUM_PENDIENTE, name: IACH_STATUS_PENDIENTE, color: "#0077BC", icon: "fas fa-spinner fa-pulse" }
  , { code: IACH_STATUS_NUM_PROCESO, name: IACH_STATUS_PROCESO, color: "#0077BC", icon: "fas fa-spinner fa-pulse" }
  , { code: IACH_STATUS_NUM_IMPORTADO, name: IACH_STATUS_IMPORTADO, color: "green", icon: "fas fa-check" }
  , { code: IACH_STATUS_NUM_ERROR, name: IACH_STATUS_ERROR, color: "red", icon: "fas fa-exclamation-circle" }
  , { code: IACH_STATUS_NUM_ERROR_ENVIO_EMAIL, name: IACH_STATUS_ERROR_ENVIO_EMAIL, color: "red", icon: "fas fa-exclamation-circle" }
];

// ==============================================================================
// Tipo PopEntryExit
// ==============================================================================

export const TIPO_POP_ENTRY = "Entry";
export const TIPO_POP_EXIT = "Exit";

export const TIPO_POP_NUM_ENTRY = "ENTRY";
export const TIPO_POP_NUM_EXIT = "EXIT";

export const TIPO_POP_SELECT = [
  { code: TIPO_POP_NUM_ENTRY, name: TIPO_POP_ENTRY }
  , { code: TIPO_POP_NUM_EXIT, name: TIPO_POP_EXIT }
];

// ==============================================================================
// Estatus Monitor Correo
// ==============================================================================

export const MCORR_STATUS_PENDIENTE = "Correo pendiente de envío";
export const MCORR_STATUS_ENVIADO = "Correo Enviado";
export const MCORR_STATUS_ERROR = "Error al enviar correo";

export const MCORR_STATUS_TABLE = {
  pendiente: { name: MCORR_STATUS_PENDIENTE, color: "#0077BC", icon: "fas fa-spinner fa-pulse" }
  , enviado: { name: MCORR_STATUS_ENVIADO, color: "green", icon: "fas fa-paper-plane" }
  , error: { name: MCORR_STATUS_ERROR, color: "red", icon: "fas fa-exclamation-circle" }
};



// WEBPACK FOOTER //
// ./src/constants/operativos.js